import { GzDialogWebComponent } from 'apps/webcomponents/src/ui/gzDialog';
import { GzDialog } from 'apps/webcomponents/src/ui/gzDialog/component/GzDialog';
import { SubmitToLabsWebComponent } from '../submitToLabs';
import { translateFn } from '../../../utils/translator.helper';
import { SubmitToLabsDialogContent } from '../../computersAndVirtualMachines/types';

export class SubmitToLabsDialog {
  static open(containerRef: HTMLElement, data: SubmitToLabsDialogContent): [GzDialogWebComponent, SubmitToLabsWebComponent] {
    const bodyContent: SubmitToLabsWebComponent = new SubmitToLabsWebComponent();
    bodyContent.setFields(data);
    const dialogConfigs: GzDialog = {
      headline: translateFn('Submit to Bitdefender Labs'),
      bodyContent,
      isOpen: true,
      isWindow: true,
    };

    return [GzDialogWebComponent.buildDialogElement(dialogConfigs, containerRef), bodyContent];
  }
}
